import theme from '@ui/theme';
import React from 'react';
import styled from 'styled-components';

const HeartIconSvg = styled.svg`
  ${p => p.hidden ? 'visibility: hidden;' : ''}
`;

const HeartIcon = (props) => {
  const {
    active = false,
    hidden = false,
    className,
  } = props;

  return (
    <HeartIconSvg
      hidden={hidden}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="24px"
      height="22px"
      viewBox="0 0 24 22"
      aria-hidden="true"
      focusable="false"
    >
      <path
        className={`heart-icon ${active ? ' .active' : ''}`}
        d="m 11.922325,20.105861 c 5.499438,-3.780892 8.888138,-7.444858 10.166099,-10.9918861 0,0 0,0 0,0 C 23.140212,6.1947204 21.626329,2.9755537 18.707071,1.9237776 17.011241,1.3127797 15.125236,1.5525469 13.636239,2.5684494 l -1.646247,1.1231528 v 0 L 10.180763,2.49566 C 7.6262308,0.80712119 4.1865417,1.5091005 2.4979679,4.0636086 1.5092658,5.5593356 1.3048856,7.4408364 1.9493491,9.1139749 c 0,0 0,0 0,0 1.4628291,3.7977351 4.7871623,7.4616941 9.9729759,10.9918861 z"
        fill={active ? theme.c['icon-heart'].active : 'none'}
        strokeWidth="2"
        stroke={active ? theme.c['icon-heart'].active : 'currentColor'}
      />
    </HeartIconSvg>
  );
};

export default HeartIcon;
